import { ActionModel, prepareAction } from "core/model/ActionModel";
import {IAmbassador} from 'core/model/ambassador'


export const ADD_AMBASSADOR = "ADD_AMBASSADOR";
export const GET_AMBASSADOR = "GET_AMBASSADOR"




function actionAddAmbassador(payload: IAmbassador): ActionModel {
    return prepareAction(ADD_AMBASSADOR, payload);
  }

  function actionGetAmbassador(payload: IAmbassador): ActionModel {
    return prepareAction(GET_AMBASSADOR, payload);
  }

export {  actionAddAmbassador , actionGetAmbassador };